import { motion } from "framer-motion";
import { Check, Minus } from "lucide-react";

const ROWS = [
  { label: "Entry price", cs: "$15/mo", cc: "$29/mo", cheq: "Custom / $$$" },
  { label: "Google Ads protection", cs: true, cc: true, cheq: true },
  { label: "Meta + Bing coverage", cs: true, cc: "Higher tiers", cheq: true },
  { label: "Competitor click prevention", cs: true, cc: true, cheq: false },
  { label: "VPN / Proxy filtering", cs: true, cc: false, cheq: true },
  { label: "Whitelabel agency reports", cs: true, cc: false, cheq: false },
  { label: "Full API access", cs: true, cc: "Enterprise only", cheq: "Enterprise only" },
  { label: "14-day free trial, no card", cs: true, cc: false, cheq: false },
];

const Cell = ({ v, highlight }) => {
  if (v === true)
    return <Check className={`w-5 h-5 mx-auto ${highlight ? "text-[#39FF14]" : "text-cyan-neon"}`} />;
  if (v === false) return <Minus className="w-5 h-5 mx-auto text-slate-600" />;
  return <span className={`text-sm ${highlight ? "text-white font-medium" : "text-slate-400"}`}>{v}</span>;
};

export const Comparison = () => {
  return (
    <section id="compare" className="relative py-24 lg:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <span className="font-mono text-xs tracking-widest uppercase text-cyan-neon">[04] The comparison</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mt-4 leading-tight">
            More coverage. Half the price.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="overflow-x-auto rounded-2xl border border-white/8 bg-[#0B101A]"
        >
          <table className="w-full min-w-[640px]">
            <thead>
              <tr className="border-b border-white/8">
                <th className="text-left p-5 font-mono text-xs tracking-widest uppercase text-slate-500 font-normal">Feature</th>
                <th className="p-5 text-center">
                  <div className="inline-flex flex-col items-center">
                    <span className="font-display text-lg text-cyan-neon">ClickShield AI</span>
                    <span className="font-mono text-[10px] tracking-wider text-[#39FF14] mt-0.5">RECOMMENDED</span>
                  </div>
                </th>
                <th className="p-5 text-center font-display text-lg text-slate-300">ClickCease</th>
                <th className="p-5 text-center font-display text-lg text-slate-300">CHEQ</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr key={r.label} className={`border-b border-white/5 ${i % 2 ? "bg-white/[0.015]" : ""}`}>
                  <td className="p-5 text-sm text-slate-300">{r.label}</td>
                  <td className="p-5 text-center bg-cyan-neon/[0.04]"><Cell v={r.cs} highlight /></td>
                  <td className="p-5 text-center"><Cell v={r.cc} /></td>
                  <td className="p-5 text-center"><Cell v={r.cheq} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>
  );
};
